<template>
  <div class="big">
    <div class="page_title">云药房中药材用药统计</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item
              index="1"
              style="font-size: 16px"
            >按药房统计</el-menu-item>
            <el-menu-item
              index="2"
              style="font-size: 16px"
            >按剂型统计</el-menu-item>
            <el-menu-item
              index="3"
              style="font-size: 16px"
            >详细统计</el-menu-item>
          </el-menu>
        </div>
        <div class="box">
          <div class="component">
            <keep-alive>
              <component :is="currentComponent" />
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DosageForm from './DosageForm';
import Hospital from './Hospital';
import Detailed from './Detailed';

export default {
  data() {
    return {
      activeIndex: '1',
      active: '1'
    };
  },
  computed: {
    currentComponent() {
      switch (this.active) {
        case '1':
          return Hospital;
        case '2':
          return DosageForm;
        case '3':
          return Detailed;
        default:
          return Hospital;
      }
    }
  },
  methods: {
    handleSelect(key) {
      this.active = key;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;

  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
